import React, { useState, useEffect } from "react";
import { connect } from 'react-redux';
import moment from 'moment';
import { toast } from 'react-toastify';

/* for "axios" request cancelation */
import axios from 'axios';

/* Helpers */
import 'moment/locale/tr';

/* Services */
import ParentService from "../../../services/parent.service";

/* Ant Design */
import { Spin, Descriptions, Badge, Button, Typography } from 'antd';

/* for "axios" request cancelation check variable */
let source;

const ParentProfile = (props) => {
    const [parent, setParent] = useState({});
    const [loadingParent, setLoadingParent] = useState(false);

    const getParent = () => {
        setLoadingParent(true);
        ParentService.getParent(source.token).then(
            res => {
                res.data.Telefon && (res.data.Telefon = "+90" + res.data.Telefon);
                setParent(res.data);
                setLoadingParent(false);
            },
            error => {
                const resMessage =
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString();
                if (resMessage === "Cancel") {
                    setLoadingParent(false);
                } else {
                    setParent({});
                    setLoadingParent(false);
                    toast.error(resMessage);
                }
            }
        )
    }

    useEffect(() => {
        source = axios.CancelToken.source();

        setLoadingParent(true);
        getParent();

        return () => {
            if (source) {
                source.cancel();
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div>
            {!loadingParent ?
                <div>
                    <div style={{ textAlign: 'center' }}>
                        <Typography.Title level={4}>
                            {parent ? parent.AdSoyad + " Profili" : "Profil"}
                        </Typography.Title>
                    </div>
                    {parent &&
                        <div style={{ textAlign: 'end' }}>
                            <Button
                                block
                                type="primary"
                                onClick={
                                    () => {
                                        props.history.push("/parent/profile/" + parent._id + "/edit");
                                    }
                                }
                                style={{ marginTop: '5vh', width: 200 }}
                            >
                                Düzenle
                            </Button>
                        </div>
                    }
                    <Descriptions
                        title="Kullanıcı Bilgileri"
                        layout="vertical"
                        column={{ xxl: 4, xl: 3, lg: 3, md: 3, sm: 2, xs: 1 }}
                        bordered
                    >
                        <Descriptions.Item label="Ad - Soyad" span={1}>{parent.AdSoyad}</Descriptions.Item>
                        <Descriptions.Item label="Doğum Tarihi" span={1}>{moment(new Date(parent.DogumTarihi)).format('LL')}</Descriptions.Item>
                        <Descriptions.Item label="Cinsiyet" span={1}>{parent.Cinsiyet}</Descriptions.Item>
                        <Descriptions.Item label="Şifre" span={1}>
                            <Button
                                onClick={
                                    () => {
                                        props.history.push("/parent/profile/password");
                                    }
                                }
                                danger
                            >
                                Değiştir
                            </Button>
                        </Descriptions.Item>
                    </Descriptions>
                    <br />
                    <Descriptions
                        title="İletişim Bilgileri"
                        layout="vertical"
                        column={{ xxl: 4, xl: 3, lg: 3, md: 3, sm: 2, xs: 1 }}
                        bordered
                    >
                        <Descriptions.Item label="E-Posta" span={1}>{parent.Eposta}</Descriptions.Item>
                        <Descriptions.Item label="Adres" span={1}>{parent.Adres}</Descriptions.Item>
                        {parent.Telefon && <Descriptions.Item label="Telefon" span={1}>{[parent.Telefon.slice(0, 3), " ", parent.Telefon.slice(3, 6), " ", parent.Telefon.slice(6, 9), " ", parent.Telefon.slice(9, 11), " ", parent.Telefon.slice(11, 13)].join('')}</Descriptions.Item>}
                    </Descriptions>
                    <br />
                    <Descriptions
                        title="Hesap Bilgileri"
                        layout="vertical"
                        column={{ xxl: 4, xl: 3, lg: 3, md: 3, sm: 2, xs: 1 }}
                        bordered
                    >
                        <Descriptions.Item label="Kayıt Tarihi" span={1}>
                            {moment(new Date(parent.KayitTarihi)).format('LL')}
                        </Descriptions.Item>
                        <Descriptions.Item label="Hesap Durumu" span={1}>
                            {parent.AktifMi ?
                                <Badge status="success" text="Aktif" />
                                :
                                <Badge status="error" text="Pasif" />
                            }
                        </Descriptions.Item>
                    </Descriptions>
                </div>
                :
                <div style={{ textAlign: 'center' }}>
                    <Spin />
                </div>
            }
        </div >
    )
}


const mapState = (state) => ({
});

const mapDispatch = (dispatch) => ({
});

export default connect(mapState, mapDispatch)(ParentProfile);